import React from 'react';

import { CellStatusVisitProps } from '../../interfaces';
import { DefaultTooltip } from './Tooltips/Default';
import { KeysTooltip } from './Tooltips/Keys';

const StatusVisit: React.FC<CellStatusVisitProps> = ({
  collaborator,
  checkin_at,
  checkout_at,
  total,
  justification,
  count_percentage,
  defaultCountPercentage,
  children,
  tooltipType,
  keysValue,
  ...rest
}) => {
  return tooltipType === 'keys' ? (
    <KeysTooltip
      value={rest.value as string}
      color={rest.color as string}
      keysValue={keysValue}
    />
  ) : (
    <DefaultTooltip
      value={rest.value as string}
      color={rest.color as string}
      collaborator={collaborator}
      checkin_at={checkin_at}
      checkout_at={checkout_at}
      total={total}
      justification={justification}
      count_percentage={count_percentage}
      defaultCountPercentage={defaultCountPercentage}
    />
  );
};

export default StatusVisit;
